<section class="text-center mt-md-5">
    <h1 class="mt-md-3 mb-2 mb-md-4">Hozzáférés megtagadva</h1>

    <p>Nincs jogosultságod ennek az oldalnak az eléréséhez: <span>{{ next }}</span></p>

    <p>Amennyiben úgy gondolod, hogy kellene, hogy legyen, vedd fel a kapcsolatot az oldal valamely
        adminisztrátorával!</p>

    <p class="mt-3 mt-md-5">
        <button type="button"
                (click)="loginAsOtherUser()"
                class="btn btn-outline-primary"
        >Másként újra belépek!
        </button>
    </p>
</section>



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/not-permitted/not-permitted.component.html